// extracted by mini-css-extract-plugin
export default {"chipContainer":"SelectedContainer_chipContainer__DqVaP","chip":"SelectedContainer_chip__7vVUT"};